export type Listener = {
    callback: Function;
    owner: Object;
    priority?: number;
};

export type EventID = string | symbol;

export type DefaultType = {____: 1;};
export type DefaultEventsMap = Record<string | symbol, DefaultType>;

export type ListenerType<DataType> = DataType extends void
    ? () => void
    : DataType extends DefaultType ? Function : (...data: DataType[]) => void;

export type ListenerPromiseType<DataType> = DataType extends void
    ? () => Promise<void>
    : DataType extends DefaultType ? Function : (...data: DataType[]) => Promise<void>;

export type ListenerTypeWithID<ID, DataType> = DataType extends void
    ? (id: ID) => void
    : (DataType extends DefaultType ? (id: ID, ...data: any[]) => void : (id: ID, ...data: DataType[]) => void);

export type EventDataType<Type> = Type extends void
    ? []
    : Type extends DefaultType ? any[] : [Type];

export interface IEventManager<EventsMap = DefaultEventsMap> {
    on<K extends keyof EventsMap>(id: K, callback: ListenerType<EventsMap[K]>, owner: Object, priority?: number): void;

    off<K extends keyof EventsMap>(id: K, owner: Object): void;

    hasListener<K extends keyof EventsMap>(id: K, owner: Object): boolean;

    emit<K extends keyof EventsMap>(id: K, ...args: EventDataType<EventsMap[K]>): void;

    getNumberEvents(): number;
    clear(): void;
}

export interface IEventManagerWithAsync<EventsMap = DefaultEventsMap> extends IEventManager<EventsMap> {
    onAsync<K extends keyof EventsMap>(
        id: K,
        callback: ListenerType<EventsMap[K]>,
        owner: Object,
        priority?: number
    ): void;

    offAsync<K extends keyof EventsMap>(id: K, owner: Object): void;

    // TODO: remove
    hasAsyncListener<K extends keyof EventsMap>(id: K, owner: Object): boolean;

    emitAsync<K extends keyof EventsMap>(id: K, ...args: EventDataType<EventsMap[K]>): void;

    offAllFromOwner(owner: Object): void;

    dispatchAsyncEvents(): void;
}
